var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { BsChevronDown } from "@react-icons/all-files/bs/BsChevronDown";
var MenuToggle = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return "\n    height: 25px;\n    width: 25px;\n    text-decoration: none;\n    color: red;\n    justify-self: end;\n    transition: all 1s;\n    transform: rotate(".concat(isOpen ? "-180" : "0", "deg);\n  ");
});
var MenuWrapper = styled.menu(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return "\n    background-color: ".concat(isOpen ? "black" : "transparent", ";\n    overflow: hidden;\n    transition: all 1s;\n    height: ").concat(isOpen ? "250px" : "50px", ";\n    display: grid;\n    grid-template-rows: repeat(auto-fill, 25px);\n    grid-gap: 1rem;\n    justify-content: right;\n    border-bottom-left-radius: 80%;\n    width: 100px;\n    padding: .5rem 1rem;\n    border: ").concat(isOpen ? "1px solid white" : "1px solid transparent", ";\n  ");
});
var MenuItem = styled.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: white;\n  list-style: none;\n  text-align: right;\n"], ["\n  color: white;\n  list-style: none;\n  text-align: right;\n"])));
var Menu = function () {
    var _a = useState(false), isOpen = _a[0], setOpen = _a[1];
    var handleToggle = useCallback(function () {
        setOpen(!isOpen);
    }, [isOpen]);
    return (React.createElement(MenuWrapper, { isOpen: isOpen },
        React.createElement(MenuToggle, { isOpen: isOpen, onClick: handleToggle },
            React.createElement(BsChevronDown, { size: "25px" })),
        React.createElement(MenuItem, null, "Home"),
        React.createElement(MenuItem, null, "Individual"),
        React.createElement(MenuItem, null, "Dispensary"),
        React.createElement(MenuItem, null, "Grower"),
        React.createElement(MenuItem, null, "FAQ")));
};
export default Menu;
var templateObject_1, templateObject_2, templateObject_3;
